import { type FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Navbar } from "../../components/layout/NavBar";
import { CrearClienteExistenteModal } from "../../components/modals/CrearClienteExistenteModal/CrearClienteExistenteModal";
import { CrearClienteModal } from "../../components/modals/CrearClienteModal/CrearClienteModal";
import { ModalAvisoBloqueo } from "../../components/modals/ModalAvisoBloqueo/ModalAvisoBloqueo";
import { ModalAvisoPago } from "../../components/modals/ModalAvisoPago/ModalAvisoPago";
import { ModalRutasNoDisponibles } from "../../components/modals/ModalRutasNoDisponibles/ModalRutasNoDisponibles";
import { Tabla } from "../../components/tablas/Tabla/Tabla";
import type { TablaAdminItem } from "../../components/tablas/Tabla/tablaTypes";
import { TablaAdministradores } from "../../components/tablas/TablaAdministradores/TablaAdministradores";
import { TablaClientes } from "../../components/tablas/TablaClientes/TablaClientes";
import type { TablaClienteItem } from "../../components/tablas/TablaClientes/types";
import {
  useAdminUsersActions,
  useAdminUsersState,
  useAuthState,
  useClientesActions,
  useClientesState,
  useRutasActions,
  useRutasState,
} from "../../context/AppContext";
import { auth } from "../../firebase/firebaseConfig";
import { formatDate2, formatearNumeros } from "../../utils/formatters";
import { calcularSaldoActualRuta } from "../../utils/rutaMovimientos";
import { CrearClienteModalNew } from "./Components/Modals/CrearClientesModal/CrearClienteModalNew";
import { RegisterRutaPage } from "./Components/Modals/RegisterRutaModal";
import {
  useActualizarCuotasOnMount,
  useCrearRutaHandler,
  useEliminarClientesPagados,
  useHomePageMetrics,
  useHomePagePaymentAlerts,
} from "./homePageHooks";
import type { HomePageProps } from "./types";

export const HomePage: FC<HomePageProps> = () => {
  const [isModalCreateRuta, setIsModalCreateRuta] = useState(false);
  const [isModalCreateClienteNew, setisModalCreateClienteNew] = useState(false);
  const [isModalCreateCliente, setisModalCreateCliente] = useState(false);
  const [isEditIndex, setisEditIndex] = useState(false);
  const [isModalCreateClienteExistente, setIsModalCreateClienteExistente] = useState(false);
  const [primerRender, setPrimerRender] = useState(true);
  const [isModalRutasNoDisponibles, setIsModalRutasNoDisponibles] = useState(false);
  const [isAvisoPago, setIsAvisoPago] = useState(false);
  const [isLockedAcount, setIsLockedAcount] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermExis, setSearchTermExis] = useState("");

  const navigate = useNavigate();
  const user = auth.currentUser;
  const { usersAdminData } = useAdminUsersState();
  const { setUsersAdminData } = useAdminUsersActions();
  const { userData } = useAuthState();
  const { infoClientes, totalAbonos } = useClientesState();
  const { setInfoClientes } = useClientesActions();
  const { rutasData, usuarioRuta } = useRutasState();
  const { setRutasData, setUsuarioRuta } = useRutasActions();
  const saldoActualRuta = calcularSaldoActualRuta(usuarioRuta);

  const { rutasDisponibles, posicionArroba, sumaPagosDiarios } = useHomePageMetrics(
    userData,
    rutasData,
    infoClientes,
  );

  useActualizarCuotasOnMount({
    primerRender,
    infoClientes,
    setInfoClientes,
    setPrimerRender,
    usuarioRuta,
  });

  useHomePagePaymentAlerts({
    userData,
    usuarioRuta,
    formatDate2,
    setRutasData,
    setInfoClientes,
    setIsAvisoPago,
    setIsLockedAcount,
  });

  useEliminarClientesPagados({
    infoClientes,
    setInfoClientes,
    usuarioRuta,
  });

  const handleCrearRuta = useCrearRutaHandler({
    rutasDisponibles,
    setIsModalRutasNoDisponibles,
    setIsModalCreateRuta,
  });

  return (
    <>
      {isModalRutasNoDisponibles ? (
        <ModalRutasNoDisponibles setIsModalRutasNoDisponibles={setIsModalRutasNoDisponibles} />
      ) : null}

      {isLockedAcount ? <ModalAvisoBloqueo usuarioRuta={usuarioRuta} userData={userData} /> : null}

      {isAvisoPago ? (
        <ModalAvisoPago
          setIsAvisoPago={setIsAvisoPago}
          userData={userData}
          usuarioRuta={usuarioRuta}
        />
      ) : null}

      {isModalCreateRuta ? (
        <RegisterRutaPage setIsModalCreateRuta={setIsModalCreateRuta} userData={userData} />
      ) : null}

      {isModalCreateCliente ? (
        <CrearClienteModal
          setisModalCreateClienteNew={setisModalCreateClienteNew}
          setisModalCreateCliente={setisModalCreateCliente}
          setIsModalCreateClienteExistente={setIsModalCreateClienteExistente}
        />
      ) : null}

      {isModalCreateClienteNew ? (
        <CrearClienteModalNew
          setisModalCreateClienteNew={setisModalCreateClienteNew}
          usuarioRuta={usuarioRuta}
          setUsuarioRuta={setUsuarioRuta}
        />
      ) : null}

      {isModalCreateClienteExistente ? (
        <CrearClienteExistenteModal
          setIsModalCreateClienteExistente={setIsModalCreateClienteExistente}
          usuarioRuta={usuarioRuta}
          setUsuarioRuta={setUsuarioRuta}
          searchTermExis={searchTermExis}
          setSearchTermExis={setSearchTermExis}
        />
      ) : null}

      <Navbar />
      <div className="w-full min-h-screen bg-gray-200 pt-16 px-4 md:px-8">
        {user?.email === "jeancenteno54@fastadmin.com" || user?.email === "jeziel@fastadmin.com" ? (
          <button
            type="button"
            className="bg-[#8131bd] mt-2 w-fit text-white px-2 py-1 rounded-md flex justify-center items-center min-w-[80px]"
            onClick={() => navigate("/registerAdm")}
          >
            Crear Admn
          </button>
        ) : null}

        {userData?.isAdmin && (
          <>
            <p className="flex font-semibold">
              Rutas disponibles:
              <span className="ml-1">{`${rutasDisponibles ? rutasDisponibles : "0"}/${
                userData?.cantidadRutas ? userData?.cantidadRutas : "0"
              }`}</span>
            </p>
            <p className="flex font-semibold">
              Ultimo pago:
              <span className="ml-1">{`${
                userData.ultimoPago ? formatDate2(userData.ultimoPago) : ""
              }`}</span>
            </p>
            <p className="flex font-semibold">
              Proximo pago:
              <span className="ml-1">{`${
                userData.ultimoPago ? formatDate2(userData.proximoPago) : ""
              }`}</span>
            </p>
            <button
              type="button"
              className="bg-[#8131bd] mt-2 w-fit text-white px-2 py-1 rounded-md flex justify-center items-center min-w-[80px]"
              onClick={handleCrearRuta}
            >
              Crear Ruta
            </button>
          </>
        )}

        {usuarioRuta && (
          <>
            <div className="w-full flex justify-between">
              <button
                type="button"
                className="bg-[#8131bd] mt-2 w-fit text-white px-2 py-1 rounded-md flex justify-center items-center min-w-[80px]"
                onClick={() => setisModalCreateCliente(true)}
              >
                Agregar cliente
              </button>

              <div className="flex flex-col items-center mt-2">
                <span className="text-xl font-bold leading-3">
                  {`R$${formatearNumeros(saldoActualRuta)}`}
                </span>
                <span className="text-xs md:text-base md:font-semibold font-bold">
                  SALDO DISPONIBLE
                </span>
              </div>
            </div>
            <div className="mt-2">
              <div className="flex items-center">
                <div className="w-[20px] h-[20px] bg-blue-700 mr-1 border border-black"></div>
                <span>Clientes mensuales</span>
              </div>
              <div className="flex items-center">
                <div className="w-[20px] h-[20px] bg-orange-950 mr-1 border border-black"></div>
                <span>Clientes semanales</span>
              </div>
              <div className="flex items-center">
                <div className="w-[20px] h-[20px] bg-red-500 mr-1 border border-black"></div>
                <span>Clientes vencidos o +8 dias sin pagar</span>
              </div>
              <div className="flex items-center">
                <div className="w-[20px] h-[20px] bg-yellow-500 mr-1 border border-black"></div>
                <span>7 dias sin pagar</span>
              </div>
              <div className="flex items-center">
                <div className="w-[20px] h-[20px] bg-green-500 mr-1 border border-black"></div>
                <span>2 a 6 dias sin pagar</span>
              </div>
              <div className="flex w-fit items-center mt-2">
                <span className="text-xs md:text-sm mr-1 md:font-semibold font-bold uppercase">
                  cuotas por cobrar:
                </span>
                <span className="font-bold ">R${formatearNumeros(sumaPagosDiarios)}</span>
              </div>
              <div className="flex w-fit items-center">
                <span className="text-xs md:text-sm mr-1 md:font-semibold font-bold uppercase">
                  Cobrado hoy:
                </span>
                <span className="font-bold ">R${formatearNumeros(totalAbonos)}</span>
              </div>
            </div>
          </>
        )}

        {userData && (
          <h2 className="text-center text-lg font-bold uppercase mt-4">
            {`Administrador: ${
              posicionArroba !== -1 ? userData.email.substring(0, posicionArroba) : null
            }`}
          </h2>
        )}

        {usuarioRuta && (
          <div className="w-full flex justify-center h-[70px] relative mt-6 ">
            <div className="absolute bottom-0 left-0 flex z-0">
              {!isEditIndex ? (
                <button
                  type="button"
                  className="bg-white font-semibold z-0 w-fit text-[#8131bd] px-2 py-1 rounded-md flex justify-center items-center min-w-[80px] shadow-lg"
                  onClick={() => setisEditIndex(true)}
                >
                  Ordenar lista
                </button>
              ) : null}

              {isEditIndex ? (
                <button
                  type="button"
                  className="bg-white font-semibold z-0 w-fit text-[#8131bd] px-2 py-1 rounded-md flex justify-center items-center min-w-[80px] shadow-lg"
                  onClick={() => setisEditIndex(false)}
                >
                  Terminar
                </button>
              ) : null}
            </div>

            <h2 className="text-lg font-bold uppercase z-0">{usuarioRuta.nombreRuta}</h2>

            <input
              type="text"
              placeholder="Buscar Cliente"
              className="absolute right-0 px-1 py-1 rounded-md bottom-0 shadow-lg"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        )}

        {user?.email === "jeancenteno54@fastadmin.com" || user?.email === "jeziel@fastadmin.com" ? (
          <div className="w-full px-2 overflow-x-auto py-2">
            <Tabla
              datos={(usersAdminData || []) as TablaAdminItem[]}
              setUsersAdminData={setUsersAdminData}
            />
          </div>
        ) : null}

        {userData?.isAdmin && (
          <div className="w-full px-2 overflow-x-auto py-2">
            <TablaAdministradores />
          </div>
        )}

        {infoClientes && (
          <div className="w-full overflow-x-auto py-2">
            <TablaClientes
              datos={infoClientes as TablaClienteItem[]}
              setSearchTermExis={setSearchTermExis}
              usuarioRuta={usuarioRuta}
              setUsuarioRuta={setUsuarioRuta}
              isEditIndex={isEditIndex}
              setisEditIndex={setisEditIndex}
              searchTerm={searchTerm}
              setIsModalCreateClienteExistente={setIsModalCreateClienteExistente}
            />
          </div>
        )}
      </div>
    </>
  );
};
